// extracted by mini-css-extract-plugin
export default {"container":"Mb","hidden":"Nb","column":"Ob","headline":"Pb"};